import { NavigatorDetail } from '@/media/changeDomain';
import {
  Alert, Button, IconChevron, TextField,
} from 'gatorcomponents';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import * as Styles from './InputDomain.styles';
import { useResize } from '@/hooks/useResize';

const InputDomain = ({
  title,
  description,
  backCta,
  continueCta,
  alertDescription,
  toggleCta,
  toggledContent,
  temporaryToggledContent,
  newDomain,
  onChangeDomain,
  onBack,
  showAutoCompleteDomain,
  autoCompleteOptions,
  onGetAutocomplete,
  domainIsOk,
  onContinue,
  loadingChange,
  originalDomain,
  mySiteLabel,
  isTemp,
}) => {
  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 960;
  const [toggle, setToggle] = useState(false);

  const handleBack = () => {
    onBack && onBack();
  };

  const handleContinue = (e) => {
    e.preventDefault();
    if (!newDomain.error) {
      onContinue && onContinue();
    }
  };

  const handleToggle = (e) => {
    e.preventDefault();
    setToggle(!toggle);
  };

  const handleChangeDomain = (e) => {
    onChangeDomain && onChangeDomain(e);
  };

  const handleGetAutocomplet = (domain) => {
    onGetAutocomplete && onGetAutocomplete(domain);
  };

  return (
    <Styles.InputDomainWrapper data-testid="input-domain-wrapper">
      <Styles.FirstRow>
        <Styles.Title>{title}</Styles.Title>
        <Styles.Description>{description}</Styles.Description>
      </Styles.FirstRow>

      {!mobile && (
        <NavigatorDetail />
      )}

      <Styles.TextFieldWrapper autoComplete="off" onSubmit={handleContinue}>
        <TextField
          label={mySiteLabel}
          onChange={handleChangeDomain}
          maxLength={63}
          value={newDomain.value}
          helpText={newDomain.error}
          status={newDomain.error ? 'error' : 'normal'}
          testId="inputDomain"
        />

        {showAutoCompleteDomain && (
          <Styles.AutoComplete>
            {autoCompleteOptions.map(item => (
              <Styles.AutoCompleteItem key={item.domain} role="button" onClick={() => handleGetAutocomplet(item.domain)}>{item.domain}</Styles.AutoCompleteItem>
            ))}
          </Styles.AutoComplete>
        )}
      </Styles.TextFieldWrapper>

      <Styles.AlertWrapper>
        <Alert
          withoutBackground
          description={alertDescription(originalDomain)}
          customIcon="IconCardRefresh"
          customIconColor="lowDark"
          centerIcon
        />

        {isTemp && (
          <Styles.ToggleWrapper>
            <Button
              variant="text"
              iconRight={(
                <IconChevron color="primaryBlue" size="md" direction={toggle ? 'top' : 'bottom'} />
              )}
              label={toggleCta}
              width="full"
              onClick={handleToggle}
            />
          </Styles.ToggleWrapper>
        )}

        <Styles.ToggleContent toggled={toggle || !isTemp}>
          {isTemp ? temporaryToggledContent : toggledContent }
        </Styles.ToggleContent>
      </Styles.AlertWrapper>

      <Styles.ActionsWrapper>
        <Button
          label={backCta}
          variant="secondary"
          onClick={handleBack}
          size="large"
          disabled={loadingChange}
          testId="backButton"
        />
        <Button
          label={continueCta}
          onClick={handleContinue}
          size="large"
          disabled={!domainIsOk || loadingChange || newDomain.error}
          loading={loadingChange}
          testId="continueButton"
        />
      </Styles.ActionsWrapper>

    </Styles.InputDomainWrapper>
  );
};

InputDomain.proptpyes = {
  title: PropTypes.string,
  description: PropTypes.string,
  backCta: PropTypes.string,
  continueCta: PropTypes.string,
  alertDescription: PropTypes.func,
  toggleCta: PropTypes.string,
  toggledContent: PropTypes.string,
  temporaryToggledContent: PropTypes.string,
  newDomain: PropTypes.string,
  onChangeDomain: PropTypes.func,
  onBack: PropTypes.func,
  onGetAutocomplete: PropTypes.func,
  showAutoCompleteDomain: PropTypes.bool,
  autoCompleteOptions: PropTypes.array,
  domainIsOk: PropTypes.bool,
  onContinue: PropTypes.func,
  loadingChange: PropTypes.bool,
  originalDomain: PropTypes.string,
  mySiteLabel: PropTypes.string,
  isTemp: PropTypes.bool,
};

export default InputDomain;
